import { render, staticRenderFns } from "./PatientAddressInfoCard.vue?vue&type=template&id=47b3a214&scoped=true&"
import script from "./PatientAddressInfoCard.vue?vue&type=script&lang=js&"
export * from "./PatientAddressInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b3a214",
  null
  
)

export default component.exports